import i18n from '@/common/i18n';
import computedLocale from '@/common/utils/computedLocale';
import {
  STATUS_ICON_LOADING,
  STATUS_ICON_CHECK_O,
  STATUS_ICON_TIMES_O,
  STATUS_ICON_DISABLED,
  STATUS_ICON_WARNING_O,
  STATE_ICON_PAUSE
} from '@/common/utils/statuses';

export const ISCSI_TYPE = 'iscsi';
export const FC_TYPE = 'fc';

export const TARGET_STATES = computedLocale(() => ({
  'not running': {
    text: i18n.t('Stopped'),
    icon: STATE_ICON_PAUSE
  },
  running: {
    text: i18n.t('Running'),
    icon: STATUS_ICON_CHECK_O
  },
  stopped: {
    text: i18n.t('Stopped'),
    icon: STATE_ICON_PAUSE
  },
  'service failed': {
    text: i18n.t('Service failed'),
    icon: STATUS_ICON_DISABLED
  },
  remote: {
    text: i18n.t('Remote'),
    icon: STATUS_ICON_CHECK_O
  },
  unregistered: {
    text: i18n.t('Unregistered'),
    icon: STATUS_ICON_DISABLED
  },
  unknown: {
    text: i18n.t('Unknown'),
    icon: STATUS_ICON_WARNING_O
  },
  synced: {
    text: i18n.t('Synced'),
    icon: STATUS_ICON_CHECK_O
  },
  syncing: {
    text: i18n.t('Syncing'),
    icon: STATUS_ICON_LOADING
  },
  failed: {
    text: i18n.t('Failed'),
    icon: STATUS_ICON_TIMES_O
  },
  offline: {
    text: i18n.t('Offline'),
    icon: STATUS_ICON_DISABLED
  },
  disabled: {
    text: i18n.t('TARGET_STATE_DISABLED'),
    icon: STATUS_ICON_DISABLED
  },
  loading: {
    text: i18n.t('Loading'),
    icon: STATUS_ICON_LOADING
  }
}));
